import { c as _c } from "react/compiler-runtime";
import { DateTimePicker, FormInput, getDate } from '@systemeio/ui';
import { UnprocessableContentError } from '@systemeio/util';
import { PublicApiSettingsCreateInterface, PublicApiSettingsCreatedInterface } from 'modules/profile/public-api-settings/types/public-api-settings-interface';
import React, { useState } from 'react';
import { CreateDataType } from 'shared/components/create-modal';
import { CreateDataInterface } from 'shared/components/listing-layout';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { PublicApiSettingsCreateErrorInterface, PublicApiSettingsErrorInterface } from '../types/public-api-settings-error-interface';
import { useCreateKey } from 'modules/profile/public-api-settings/hooks/use-create-keys';
import { usePublicKeys } from 'modules/profile/public-api-settings/hooks/use-public-keys';
const defaultValues = {
  name: '',
  expiresAt: ''
};
const defaultErrors = {
  name: '',
  expiresAt: ''
};
interface UseCreateDataPublicApiKeysProps {
  onCreate: (data: PublicApiSettingsCreatedInterface) => Promise<void>;
}
export const useCreateDataPublicApiKeys = t0 => {
  const $ = _c(33);
  const {
    onCreate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [errors, setErrors] = useState(defaultErrors);
  const {
    user,
    intlLocale
  } = useUser();
  const {
    apiKeys
  } = usePublicKeys();
  const {
    createApiKey
  } = useCreateKey();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => setErrors(defaultErrors);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onCreateModalOpen = t1;
  let t2;
  if ($[1] !== createApiKey || $[2] !== onCreate) {
    t2 = async t3 => {
      const {
        name,
        expiresAt
      } = t3;
      ;
      try {
        setErrors(defaultErrors);
        const data = await createApiKey({
          name,
          expiresAt
        });
        await onCreate(data);
        return data;
      } catch (t4) {
        const e = t4;
        if (e instanceof UnprocessableContentError) {
          const errors_0 = (e as any).errors as PublicApiSettingsErrorInterface;
          errors_0.violations.forEach(t5 => {
            const {
              propertyPath,
              message
            } = t5;
            return Object.keys(defaultErrors).includes(propertyPath) && setErrors(prev => ({
              ...prev,
              [propertyPath]: message
            }));
          });
        }
        throw e;
      }
    };
    $[1] = createApiKey;
    $[2] = onCreate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onCreateKey = t2;
  const t3 = !apiKeys || apiKeys?.length >= 3;
  let t4;
  if ($[4] !== t) {
    t4 = t("dashboard.user_settings.public_api.title");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("dashboard.user_settings.public_api.create_title");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["name"];
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onCreateKey) {
    t7 = async data_0 => {
      await onCreateKey(data_0);
    };
    $[9] = onCreateKey;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== errors || $[12] !== t) {
    t8 = {
      field: "name",
      onRender: (value, onChange) => <FormInput required={true} key="key-name" label={t("dashboard.user_settings.public_api.name")} value={value} onChange={e_0 => onChange(e_0.target.value)} maxLength={256} error={errors.name} />
    };
    $[11] = errors;
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== errors || $[15] !== intlLocale || $[16] !== t || $[17] !== user?.createdAt || $[18] !== user?.dateFormat || $[19] !== user?.timeFormat || $[20] !== user?.timezone) {
    t9 = {
      field: "expiresAt",
      onRender: (value_0, onChange_0) => <DateTimePicker label={t("dashboard.user_settings.public_api.expires_at")} key="expiresAt" value={value_0 || null} onChange={date => {
        onChange_0(date || undefined);
      }} customProps={{
        minDate: getDate(new Date(new Date().setHours(new Date().getHours() + 744)).toISOString(), user?.timezone)
      }} error={errors.expiresAt} createdAt={user?.createdAt} timezone={user?.timezone} userDateFormat={user?.dateFormat} userTimeFormat={user?.timeFormat} intlLocale={intlLocale} />
    };
    $[14] = errors;
    $[15] = intlLocale;
    $[16] = t;
    $[17] = user?.createdAt;
    $[18] = user?.dateFormat;
    $[19] = user?.timeFormat;
    $[20] = user?.timezone;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = [t8, t9];
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t3 || $[27] !== t4 || $[28] !== t5 || $[29] !== t7) {
    t11 = {
      disabled: t3,
      caption: t4,
      fullCaption: t5,
      requiredFields: t6,
      onOpen: onCreateModalOpen,
      onCreate: t7,
      defaultValues,
      creatable: t10
    };
    $[25] = t10;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t7;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const t12 = t11 as CreateDataInterface<PublicApiSettingsCreateInterface>;
  let t13;
  if ($[31] !== t12) {
    t13 = {
      createData: t12
    };
    $[31] = t12;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};